import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import pages from "../../constants/pages";
import { useAxios } from "../../hooks";
import { PageHeader, Pagination } from "../../components";
import List from "./lead campaign list components/List";
import { PrimaryButton } from "../css components/Button";
import FloatingAddActionButtons from "../../components/FloatingAddActionButton";

export default function LeadCampaignList() {
  const axios = useAxios();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [campaignList, setCampaignList] = useState([]);
  const [lastPage, setLastPage] = useState({ totalCount: 0, lastPage: false });

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);
    axios({
      url:
        "/get/leadCampaignList/" +
        activeBrand.ID +
        `?page=${page}&limit=10` +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : ""),
    }).then((response) => {
      if (response.status) {
        if (response.data.leadCampaignData.length > 0) {
          setLastPage({
            totalCount: response.data.totalCount,
            lastPage: response.data.leadCampaignData.length < 10,
          });

          setCampaignList(response.data.leadCampaignData);
        } else {
          setCampaignList([]);
          setLastPage(true);
        }
      }
      setLoading(false);
    });
  }, [axios, activeBrand.ID, page, searchKey]);

  function handlePagination(step, index) {
    setPage((prev) =>
      step === "index" ? index : prev + (step === "next" ? 1 : -1)
    );
  }

  return (
    <Fragment>
      <PageHeader
        pageName={"Lead Qualification as a Service (LAAS)"}
        buttons={[
          <PrimaryButton
            variant="contained"
            onClick={() => navigate(pages.leadCampaign.route)}
          >
            Create Lead Qualification
          </PrimaryButton>,
        ]}
      />

      <FloatingAddActionButtons
        route={pages.leadCampaign.route}
        title={"Create Lead Qualification"}
      />

      <List
        campaignList={campaignList}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
      />

      {!!lastPage.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(lastPage.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
